import "./styles.css";
import { useState, useEffect, useMemo } from "react";
import { LoadingOutlined, CopyOutlined } from "@ant-design/icons";
import { Spin, Alert, Typography, message, Tooltip } from "antd";
import ApiTokenManagement from "../../api/token-management";
import QrCodeCard from "../qr-code/qr-code-card";

const { Text } = Typography;

const ScenarioSimulatorQr = ({ itemType, scenario, scenarioVersionId, scenarioId }) => {
  const [isReady, setReady] = useState(false);
  const [link, setLink] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    const dataType = itemType + "-preview";

    (async () => {
      try {
        const response = await ApiTokenManagement.generateAppQrLink({
          route: "lifebot",
          dataType,
          id: scenarioId,
          versionId: scenarioVersionId,
        });

        const routeLink = response?.data?.link;

        if (mounted) {
          setLink(routeLink || "");
          setReady(true);
        }
      } catch (e) {
        console.error("generateAppQrLink error:", e);
        if (mounted) {
          setError("generate QR link error");
          setReady(true);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [itemType, scenario?.id, scenarioVersionId, scenarioId]);

  const displayLink = useMemo(() => {
    if (!link) return "";
    const base = link.split("?")[0] || link;
    return `${base}…`;
  }, [link]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      message.success("Link copied to clipboard!");
    } catch {
      message.error("Failed to copy link.");
    }
  };

  const entityLabel = useMemo(() => {
    switch (itemType) {
      case "article":
        return "article";
      case "onboarding":
        return "scenario";
      case "surveyTask":
        return "scenario";
      case "scenario":
      default:
        return "scenario";
    }
  }, [itemType]);

  if (!isReady) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Spin
          className="scenario-simulator-content-loader"
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        />
      </div>
    );
  }

  if (error) {
    return <Alert type="error" title={error} />;
  }

  return (
    <div style={{ width: "100%" }}>
      <hr
        style={{
          border: 0,
          borderTop: "1px solid #ddd",
          marginBottom: 16,
          marginLeft: -24,
          marginRight: -24,
          width: "calc(100% + 48px)",
        }}
      />

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div
          style={{
            flexShrink: 0,
            width: 117,
            height: 117,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <QrCodeCard value={link} size={117} />
        </div>
        <div style={{ marginLeft: 16, flex: 1 }}>
          <p style={{ fontSize: 14, lineHeight: 1.5, color: "#444", margin: 0 }}>
            Scan the QR code or open the link on your phone to preview the {entityLabel}. <br />
            Make sure you have the <strong>LifeFit360</strong> app installed.
          </p>
        </div>
      </div>

      <hr
        style={{
          border: 0,
          borderTop: "1px solid #ddd",
          margin: "16px -24px",
          width: "calc(100% + 48px)",
        }}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Text
          style={{
            flex: 1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 14,
            fontWeight: 400,
            color: "#444",
            cursor: "default",
          }}
          title={link}
        >
          {displayLink}
        </Text>

        <Tooltip title="Copy full link">
          <CopyOutlined
            onClick={handleCopy}
            style={{ marginLeft: 12, cursor: "pointer", fontSize: 16, color: "#444" }}
            aria-label="Copy link"
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default ScenarioSimulatorQr;